import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { modalConfirmActions } from '../../modules/Actions';

export interface ModalConfirmState {
  isOpen: boolean;
  title: string;
  msg: string | React.ReactNode;
  primaryBtnText: string;
  isLoading: boolean;
  isDanger: boolean;
  callBack?: () => void | undefined;
  type?: string;
}

export const initialState: ModalConfirmState = {
  isOpen: false,
  title: '',
  msg: '',
  primaryBtnText: '',
  isLoading: false,
  isDanger: false,
  type: '',
};

export const ModalConfirmReducer = reducerWithInitialState(initialState)
  .case(modalConfirmActions.trigglerModal, (state: ModalConfirmState, payload: ModalConfirmState) => {
    return payload;
  })
  .case(modalConfirmActions.closeModal, (state: ModalConfirmState) => {
    return {
      ...state,
      isOpen: false,
    };
  })
  .case(modalConfirmActions.handleLoading, (state: ModalConfirmState, payload: boolean) => {
    return {
      ...state,
      isLoading: payload,
    };
  });
